import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

/**
 * Configures and exports the Redux store with the root reducer.
 * 
 * @constant
 * @type {Store}
 */
export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
